// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"messageWithContext--next-sr-only--1hbznvI","fixedMessage":"messageWithContext--fixedMessage--2iOrnKo"};